//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';

import utils from './proj/utils';
import handleLazySizes from './proj/handleLazySizes';
import handleContainSizing from './proj/handleContainSizing';
// import Slick from './proj/slick';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText); 


let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;


(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			
			// Get main element
			var barEl = document.getElementById('cnn-header');
			if(barEl) {
				self.navshare();
			}

			// self.scrollToAnchor();
			self.newWindowLink();
			self.toggleVideo();
			self.imagePlx();
			self.handleVideoSrc();
			self.playVideoIntro();
			self.firstLoadAnimation();
		},

		toggleVideo: function(){

			const self = this;

			var iframe = document.querySelector('iframe');
			var player = new Vimeo.Player(iframe);

			self.loadVideoTracking(iframe);

			$('.video .js-poster').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				$('.video').toggleClass('is-open');

				if($('.video').hasClass('is-open')) {
					player.play();
				}
				else {
					player.pause()
				}
			});

			// player
			ScrollTrigger.create({
				trigger: '.video',
				scrub: true,
				// markers: true,
				start: "top top",
				end: "+="+($('.video').height() - 120),
				onLeave: function(){
					if($('.video').hasClass('is-open')) {
						player.pause()
					}
				},
				onEnterBack: function(){
					if($('.video').hasClass('is-open')) {
						// player.play()
					}
				},
			});

		},
		firstLoadAnimation: function(){
			var tlh1 = gsap.timeline({paused: true}),
				h1SplitText = new SplitText("h1", { 
					type: "words, chars",
				}),

				chars = h1SplitText.chars; //an array of all the divs that wrap each character

				tlh1.from(chars, {
					duration: 1,
					opacity: 0,
					scale: 0.9,
					y: 0,
					ease: "back",
					stagger: 0.01
				});			


			// HERO
			gsap.timeline({ease: "linear"})
				.to('#app', { autoAlpha:1 })
				.from('.hero-clientlogo', { opacity: '0', scale: 1, y: '10px', duration: 1 })
				.call(function(argument) {
					tlh1.play();
				})
				.from('.hero .video__media', {  opacity: '0', y: '10%', duration: 0.7 }, "-=0.1")
				.from('.hero-tagline', { opacity: '0', y: '20%', duration: 0.7 }, "+=0.8")



			$('.js-graphic-xl').each(function(index, section){
				gsap.set($(section).find('.plx1'), {y: '-6%'});
				gsap.set($(section).find('.plx2'), {y: '-6%'});

				let tl = gsap.timeline()
     						.to($(section).find('.plx1'), { y: '5%', duration: 1 })
     						.to($(section).find('.plx2'), { y: '2%', duration: 1 }, '<');

				ScrollTrigger.create({
					trigger: section,
					scrub: true,
					start: "top bottom",
					end: "bottom top",
					animation: tl
					// onEnter: function(){
						// gsap.from($(section).find('.plx1'), { y: '-30px', duration: 1 })
					// }
				});
			});

			$('.js-graphic-xxl').each(function(index, section){
				gsap.set($(section).find('.l1'), {y: '0%'});
				gsap.set($(section).find('.l2'), {y: '-16%'});
				gsap.set($(section).find('.l3'), {y: '-8%'});
				gsap.set($(section).find('.l4'), {y: '-16%'});
				gsap.set($(section).find('.l5'), {y: '-15%'});

				let tl = gsap.timeline()
     						.to($(section).find('.l2'), { y: '5%', duration: 1 }, '<')
     						.to($(section).find('.l3'), { y: '10%', duration: 1 }, '<')
     						.to($(section).find('.l4'), { y: '0%', duration: 1 }, '<')
     						.to($(section).find('.l5'), { y: '10%', duration: 1 }, '<');

     			var played = false; 
				ScrollTrigger.create({
					trigger: section,
					scrub: true,
					start: "top bottom",
					end: "bottom top",
					animation: tl,
					onEnter: function(){

						if(played != true) {	
							gsap.timeline().from($(section).find('.l5'), { opacity: '0', duration: 1 })
							.from($(section).find('.l1'), { opacity: '0', duration: 1 }, '-=0.8')
							.from($(section).find('.l2'), { opacity: '0', duration: 1 }, '-=0.8')
							.from($(section).find('.l3'), { opacity: '0', duration: 1 }, '-=0.8')
							.from($(section).find('.l4'), { opacity: '0', duration: 1 }, '-=0.8')
							played = true;
						}
					}
				});
			});


			$('.js-graphic-s').each(function(index, section){
				gsap.set($(section).find('.plx1'), {y: '-2%'});

				let tl = gsap.timeline()
     						.to($(section).find('.plx1'), { y: '5%', duration: 1 })

				ScrollTrigger.create({
					trigger: section,
					scrub: true,
					start: "top bottom",
					end: "bottom top",
					animation: tl,
					onEnter: function(){
						gsap.from($(section).find('.plx1'), { y: '-30px', duration: 1 })
					}
				});
			});

			
			$('.graphic--1').each(function(index, section){
				// var elts = $(this).children();
				gsap.set($(section).find('.l1'), {opacity: 0, y:10});
				gsap.set($(section).find('.l2'), {opacity: 0, y:30});

				ScrollTrigger.create({
					trigger: section,
					start: "top 70%",
					once: true,
					onEnter: function(){
						gsap.timeline().to($(section).find('.l2'), { opacity: '1', y:0, duration: 1 })
						.to($(section).find('.l1'), { opacity: '1', y:0, duration: 1 }, '-=0.8')
					}
				});
			})
			$('.graphic--2, .graphic--3').each(function(index, section){
				// var elts = $(this).children();
				gsap.set($(section).find('.l1'), {opacity: 0, y:10});
				gsap.set($(section).find('.l2'), {opacity: 0, y:30});
				gsap.set($(section).find('.line'), {opacity: 0, y:0});

				ScrollTrigger.create({
					trigger: section,
					start: "top 70%",
					once: true,
					onEnter: function(){
						gsap.timeline().to($(section).find('.l2'), { opacity: '1', y:0, duration: 1 })
						.to($(section).find('.l1'), { opacity: '1', y:0, duration: 1 }, '-=0.8')
						.to($(section).find('.line'), { opacity: '1', y:0, duration: 0.5 }, '-=0.5')
					}
				});
			})
			
			$('.s2-graphic, .s4-graphic').each(function(index, section){
				// var elts = $(this).children();
				// gsap.set(elts, {y: 0, opacity: 0});
				// gsap.set($(section).find('h2'), {opacity: 0, y:50 });
				gsap.set($(section).find('.ge-copy--large'), {opacity: 0, y:30});

				ScrollTrigger.create({
					trigger: section,
					start: "top 70%",
					once: true,
					onEnter: function(){
						gsap.timeline()
						// .to($(section).find('h2'), { opacity: '1', y:0, duration: 1 })
						// .from($(section).find('.graphic'), { opacity: '0', duration: 1 }, '-=0.8')
						.to($(section).find('.ge-copy--large'), { opacity: '1', y:0, duration: 1 }, '-=0.8')
						// .from($(section).find('.l3'), { opacity: '0', duration: 1 }, '-=0.8')
						// .from($(section).find('.l4'), { opacity: '0', duration: 1 }, '-=0.8')
					}
				});
			})


			$('.ge-visiontitle strong').each(function(index, title){

				var tl_title = gsap.timeline({paused: true}),
					mySplitText = new SplitText(title, { 
						type: "words, chars",
						linesClass: "split-parent"
					}),
					chars = mySplitText.chars; //an array of all the divs that wrap each character


				tl_title.from(chars, {
					duration: 1,
					opacity: 0,
					scale: 0.9,
					y: 0,
					ease: "back",
					stagger: 0.03
				});				

				ScrollTrigger.create({
					trigger: title,
					scrub: true,
					// markers: true,
					once: true,
					start: "top 100%",
					onEnter: function(){
						setTimeout(function(){
							tl_title.play(0);
						}, 1000)
					}
				});


			});

			$('.section4 .ge-cols--graphics').each(function(){
				var elts = $(this).children();
				gsap.set(elts, {y: 0, opacity: 0});

				ScrollTrigger.batch(elts, {
					// markers: true,
					start: "top 70%",
					once: true,
					onEnter: function(batch){  gsap.to(batch, {opacity: 1, y: 0, stagger: 0.5, overwrite: true})},
				});
			})


			$('.ge-image').each(function(index, section){
				var elt = $(this);
				gsap.set(elt, {y: '15%' });

				ScrollTrigger.create({
					trigger: section,
					start: "top 100%",
					once: true,
					onEnter: function(){
						gsap.to(elt, { y: '0', duration: 0.8 })
					}
				});
			})


			// $('.video').each(function(index, section){
			// 	ScrollTrigger.create({
			// 		trigger: section,
			// 		scrub: true,
			// 		start: "top bottom",
			// 		end: "bottom 50%",
			// 		// animation: gsap.from($(section).find('.video__media img'), { y: '20%', duration: 1 })
			// 		onEnter: function(){
 			// 			gsap.from($(section).find('.video__media'), { y: '10%', duration: 1 })
			// 		}
			// 	});
			// });

			$('.ivanim-slidefade').each(function(){
				var elts = $(this);

				gsap.set(elts, {y: 30, opacity: 0});

				ScrollTrigger.create({
					trigger: elts,
					// markers: true,
					start: "top 95%",
					onEnter: function(){  gsap.to(elts, {opacity: 1, y: 0, duration: 0.6}) },
				});
			});
			$('.ivanim-fade').each(function(){
				var elts = $(this);

				gsap.set(elts, {opacity: 0});

				ScrollTrigger.create({
					trigger: elts,
					// markers: true,
					start: "top 95%",
					onEnter: function(){  gsap.to(elts, {opacity: 1, duration: 0.7}) },
				});
			})  



			// END CTA
			gsap.set('.end-cta-clientlogo, .end-cta-title__title, .end-cta-title__ctas', {'opacity': 0});
			gsap.set('.end-cta-media img', { scale: '1.1' });

			var tlEndCTA = gsap.timeline({paused: true, ease: "linear"})
					.to('.end-cta-media img', { scale: '1', duration: 1 })
					.to('.end-cta-clientlogo', { opacity: '1', duration: 1 }, '<')
					.to('.end-cta-title__title', { opacity: '1', duration: 1 }, '-=0.5')
					.to('.end-cta-title__ctas', { opacity: '1', duration: 1 }, '-=0.5')

			ScrollTrigger.create({
				trigger: ".end-cta", 
				// markers: true,
				pin: false,
				start: "top 90%",
				once: true,
				onEnter: function(){
					tlEndCTA.restart();
				}
			});

			// ScrollTrigger.saveStyles('.image-text__media, .image-fullwidth__media, .video__media');

			window.addEventListener("resize", utils.debounce(function(e){
				ScrollTrigger.refresh(true);
			}));

		},

		imagePlx: function(){
			$('.figure-container-plx').find('img').each(function(){
				$(this).on('load', function(){
					var w = $(this).width();
					var h = $(this).height() - 50;

					// use svg to set image size
					$(this).parents('.figure-container-plx').find('svg').attr('width', w);
					$(this).parents('.figure-container-plx').find('svg').attr('height', h);
					$(this).parents('.figure-container-plx').find('svg').attr('viewBox', "0 0 "+w+" "+h);
					$(this).addClass('plx');

					ScrollTrigger.create({
						trigger: $(this),
						scrub: true,
						// markers: true,
						start: "top bottom",
						end: "bottom top",
						animation: gsap.to($(this), { y: '50px' })
					});
				}).bind('error',function(ev){
					// console.log('===  main.js [794] ===', ev);
				});

			});
		},

		/**
		 * video replace
		 *
		 */
		handleVideoSrc: function() {

			const updateVideoSrc = function(vid) {
				const src = vid.getAttribute('data-vid-src');
				const newSrc = (isMobile) ? src.replace(".mp4", "-mob.mp4") : src;
				const hasPoster = vid.getAttribute('data-hasposter');
				if (hasPoster) {
					vid.setAttribute('poster', (isMobile) ? hasPoster + '-mob.jpg' : hasPoster + '.jpg');
				}
				vid.setAttribute('src', newSrc);
			};

			const vids = document.querySelectorAll("video[data-vid-src]");
			[...vids].forEach( updateVideoSrc );

			
		},
		playVideoIntro: function(){

			const playVideo = function(vid) {

				var playPromise = vid.play();

				if (playPromise !== undefined) {
					playPromise.then(function() {
						// Automatic playback started!
					}).catch(function(error) {
						vid.muted = true;
						vid.play();
						// Automatic playback failed.
						// Show a UI element to let the user manually start playback.
					});
				}
			};
			const pauseVideo = function(vid) {
				vid.pause();
			};

			//reset video to start
			var v = document.getElementById('intro_video');


			playVideo(v);
			// console.log('===  main.js [185] ===', v);
			
			ScrollTrigger.create({
				trigger: '.hero',
				onLeave: function(){
					pauseVideo(v);
				},
				onEnter: function(){
					// playVideo(v);
				},
				onEnterBack: function(){
					playVideo(v);
				},
				onLeaveBack: function(){
					// pauseVideo(v);
				},
				// markers: true,
				// id: 'hero-cte',
				start: "top -60px",
				// end: "bottom 50%",
			});


		},


		navshare: function(){
			const self = this;
			// Setup social share menu
			var barEl = document.getElementById('cnn-header');
			var shareEl = barEl.querySelector('[data-share]');
			var shareToggleEl = barEl.querySelector('[data-share-toggle]');

			if(shareToggleEl) {
				shareToggleEl.addEventListener('click', function(){
					if(shareEl.classList.contains('cnn-header__share--active')){
						shareEl.classList.remove('cnn-header__share--active');
					} else {
						shareEl.classList.add('cnn-header__share--active');
					}
				}, false);
			}

			// Set up scroll handler
			document.addEventListener('scroll', function() {
				window.requestAnimationFrame(self.onScroll);
			}, {passive: true});

		},
		onScroll: function(){
			// Get current scroll position
			var sPos = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;

			var barEl = document.getElementById('cnn-header');
			if(sPos < 30) {
				if(barEl.classList.contains('cnn-header--fixed')) {
					barEl.classList.remove('cnn-header--fixed');
				}
			} else {
				if(!barEl.classList.contains('cnn-header--fixed')) {
					barEl.classList.add('cnn-header--fixed');
				}
			}
		},


		/**
		 * Scroll to
		 *
		 */
		scrollToAnchor: function () {
			$('body').on('click', '.scrollTo', function(event){
				event.preventDefault();
				event.stopPropagation();

				var tag = $(this).attr('href');

				$('html,body').animate({scrollTop: $(tag).offset().top },'slow');
			});
		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {
			$('p a[href]').not('.goto').each(function() {

				// if(!$(this).attr('href').indexOf('cnn') != -1) {
					$(this).attr('target','_blank');
				// }
			});
		},		

		/**
		 * CNN video view trackers
		 *
		 */
		loadVideoTracking: function($iFrame){
			var player = new Vimeo.Player($iFrame);
			var playedVideoTrackingFlag = true;
			var startPlayedVideoTrackingFlag = true;

			player.getVideoTitle().then(function(title) {
				// console.log('title:', title);
		
				function playedVideoTracking(title) {
					s.events = 'event32';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					s.tl(true, 'o', 'cnnadfeaturevideo:play');
					s.events = s.prop29 = s.eVar41 = '';
				}
			
				function startPlayedVideoTracking(title) {
					s.events = 'event32';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone');
					s.events = s.prop29 = s.eVar41 = '';
				}
			
				function tenPlayedVideoTracking(title) {
					s.events = 'event40,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 10% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function twentyFivePlayedVideoTracking(title) {
					s.events = 'event41,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 25% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function fiftyPlayedVideoTracking(title) {
					s.events = 'event2,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 50% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function seventyFivePlayedVideoTracking(title) {
					s.events = 'event42,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 75% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function endVideoTracking(title) {
					s.events = 'event33,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				player.on('play', function() {
					playedVideoTracking(title);
					// playedVideoTrackingFlag = false;
					// console.log('Played the video');
				});
			
			
				var loopCount = 0;
				var tenPlayedVideoTrackingFlag = false;
				var twentyFivePlayedVideoTrackingFlag = false;
				var fiftyPlayedVideoTrackingFlag = false;
				var seventyFivePlayedVideoTrackingFlag = false;
				var endVideoTrackingFlag = false;
			
				player.on('timeupdate', function(data) {
					var iNum = data.percent;
					
					if (iNum >= 0.101 && loopCount == 0 && !tenPlayedVideoTrackingFlag) {
						// console.log("Played 10%");
						tenPlayedVideoTrackingFlag = true;
						tenPlayedVideoTracking(title);
					}
					if (iNum >= 0.25 && loopCount == 0 && !twentyFivePlayedVideoTrackingFlag) {
						// console.log("Played 25%");
						twentyFivePlayedVideoTrackingFlag = true;
						twentyFivePlayedVideoTracking(title);
					}
					if (iNum >= 0.50 && loopCount == 0 && !fiftyPlayedVideoTrackingFlag) {
						// console.log("Played 50%");
						fiftyPlayedVideoTrackingFlag = true;
						fiftyPlayedVideoTracking(title);
					}
					if (iNum >= 0.75 && loopCount == 0 && !seventyFivePlayedVideoTrackingFlag ) {
						// console.log("Played 75%");
						seventyFivePlayedVideoTrackingFlag = true;
						seventyFivePlayedVideoTracking(title);
					}
					if (iNum >= 0.99 && loopCount == 0 && !endVideoTrackingFlag) {
						// console.log("Completed");
						endVideoTrackingFlag = true;
						endVideoTracking(title);
						loopCount += 1;
					}
				});
			});
		},
	};

	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js